import { createReducer } from '@reduxjs/toolkit';
import { PaymentProcessSteps } from 'core/payments/entities';
import {
  clearPaymentState,
  initializePaymentFormFailed,
  initializePaymentFormPending,
  initializePaymentFormSucceed,
  initializeResignFormFailed,
  initializeResignFormPending,
  initializeResignFormSucceed,
  paymentFormFailed,
  paymentFormSucceed,
  paymentFormVerify,
  paymentMethodsSucceed,
  recurringPaymentFailed,
  recurringPaymentPending,
  recurringPaymentSucceed,
  recurringPaymentThreeDomainSecure,
  resignFormFailed,
  resignFormSucceed,
  updateOrderData,
  updateOrderId,
  updatePaymentType,
} from './actions';
import { paymentsInitialState } from './state';

export const paymentsReducer = createReducer(paymentsInitialState, (builder) => {
  builder
    .addCase(updateOrderId, (state, { payload }) => {
      state.orderId = payload;
    })
    .addCase(initializePaymentFormPending, (state) => {
      state.paymentProcessStep = PaymentProcessSteps.IN_PROCESS;
      state.paymentError = null;
      state.formPaypalData = paymentsInitialState.formPaypalData;
      state.formMerchantData = paymentsInitialState.formMerchantData;
    })
    .addCase(initializePaymentFormSucceed, (state, { payload }) => {
      state.paymentProcessStep = PaymentProcessSteps.INITIALIZED;
      state.formMerchantData = payload.formMerchantData;
      state.formPaypalData = payload.paypalPaymentData;
    })
    .addCase(initializePaymentFormFailed, (state, { payload }) => {
      state.paymentProcessStep = PaymentProcessSteps.FAILED;
      state.paymentError = payload;
    })
    .addCase(paymentFormVerify, (state) => {
      state.paymentProcessStep = PaymentProcessSteps.VERIFY;
    })
    .addCase(recurringPaymentThreeDomainSecure, (state, { payload }) => {
      state.paymentProcessStep = PaymentProcessSteps.THREE_DOMAIN_SECURE;
      state.recurringData = payload;
    })
    .addCase(recurringPaymentPending, (state) => {
      state.paymentProcessStep = PaymentProcessSteps.IN_PROCESS;
      state.paymentError = null;
    })
    .addCase(recurringPaymentSucceed, (state) => {
      state.paymentProcessStep = PaymentProcessSteps.SUCCESS;
    })
    .addCase(recurringPaymentFailed, (state, { payload }) => {
      state.paymentProcessStep = PaymentProcessSteps.FAILED;
      state.paymentError = payload;
    })
    .addCase(initializeResignFormPending, (state) => {
      state.paymentProcessStep = PaymentProcessSteps.IN_PROCESS;
      state.resignFormData = null;
      state.paymentError = null;
    })
    .addCase(initializeResignFormSucceed, (state, { payload }) => {
      state.paymentProcessStep = PaymentProcessSteps.RESIGN_INITIALIZED;
      state.resignFormData = payload;
    })
    .addCase(initializeResignFormFailed, (state, { payload }) => {
      state.paymentProcessStep = PaymentProcessSteps.FAILED;
      state.paymentError = payload;
    })
    .addCase(resignFormSucceed, (state) => {
      state.paymentProcessStep = PaymentProcessSteps.SUCCESS;
    })
    .addCase(resignFormFailed, (state) => {
      state.paymentProcessStep = PaymentProcessSteps.FAILED;
    })
    .addCase(paymentFormSucceed, (state) => {
      state.paymentProcessStep = PaymentProcessSteps.SUCCESS;
    })
    .addCase(paymentFormFailed, (state, { payload }) => {
      state.paymentProcessStep = PaymentProcessSteps.FAILED;
      state.paymentError = payload;
    })
    .addCase(paymentMethodsSucceed, (state, { payload }) => {
      state.paymentCardBank = payload.cardBank;
      state.paymentCardBrand = payload.cardBrand;
      state.paymentCardType = payload.cardType;
      state.paymentType = payload.type;
    })
    .addCase(updatePaymentType, (state, { payload }) => {
      state.paymentType = payload;
    })
    .addCase(clearPaymentState, (state) => {
      return {
        ...state,
        paymentProcessStep: PaymentProcessSteps.IDLE,
        paymentError: null,
        formMerchantData: paymentsInitialState.formMerchantData,
        formPaypalData: paymentsInitialState.formPaypalData,
        resignFormData: null,
        recurringData: null,
      };
    })
    .addCase(updateOrderData, (state, { payload }) => {
      state.orderData = payload;
    });
});
